import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Timer, Lightning, ArrowsClockwise } from '@phosphor-icons/react';
import { fmtDatetime } from './helpers';

export const EVVSchedulerCard = ({
  enabled, lastRun, toggling, triggerRunning,
  onToggle, onTriggerNow, onShowHistory,
}) => (
  <Card className="border-slate-200" data-testid="scheduler-card">
    <CardContent className="pt-4 pb-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
            <Timer size={22} weight="duotone" className="text-indigo-700" />
          </div>
          <div>
            <h3 className="font-semibold text-sm text-slate-900">Auto-Submit Scheduler</h3>
            <p className="text-xs text-slate-500">
              {enabled
                ? `Runs every hour. Last run: ${lastRun ? fmtDatetime(lastRun.run_at) : 'Never'}`
                : 'Disabled. Enable to auto-submit approved entries every hour.'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {lastRun && (
            <div className="flex gap-2 text-xs">
              <span className="bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded">
                {lastRun.accepted || 0} accepted
              </span>
              {(lastRun.failed || 0) > 0 && (
                <span className="bg-red-50 text-red-700 px-2 py-0.5 rounded">{lastRun.failed} failed</span>
              )}
            </div>
          )}
          <Button variant="outline" size="sm" onClick={onShowHistory} data-testid="scheduler-history-btn">
            History
          </Button>
          <Button variant="outline" size="sm" disabled={triggerRunning} onClick={onTriggerNow} data-testid="trigger-scheduler-btn">
            {triggerRunning ? (
              <ArrowsClockwise size={14} className="mr-1 animate-spin" />
            ) : (
              <Lightning size={14} className="mr-1" />
            )}
            Run Now
          </Button>
          <div className="flex items-center gap-2">
            <Switch checked={enabled} disabled={toggling} onCheckedChange={onToggle} data-testid="scheduler-toggle" />
            <span className="text-xs font-medium text-slate-600">{enabled ? 'ON' : 'OFF'}</span>
          </div>
        </div>
      </div>
    </CardContent>
  </Card>
);
